export default {
    dataSuccess(state, data) {
        state.locale = data;
    },
};
